export default __webpack_public_path__ + "static/media/jadekenneth.acc1c0c3.jpg";